import { useService } from 'react-reservice';

import { signUpCrmService } from './service';

export const useSignupCrm = () => useService(signUpCrmService, (context) => context);
